import { render } from "./NuestrosPartners.vue?vue&type=template&id=166de8f4&scoped=true&class=banner"
import script from "./NuestrosPartners.vue?vue&type=script&lang=js"
export * from "./NuestrosPartners.vue?vue&type=script&lang=js"

import "./NuestrosPartners.vue?vue&type=style&index=0&id=166de8f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166de8f4"]])

export default __exports__